export default __webpack_public_path__ + "ce05375717af225c8c9de74255369076.svg";